import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { throttle } from "lodash-es";
import React from "react";
import { Provider } from "react-redux";

import { loadState, saveState } from "../local-storage";
import { BrandingStore, OrgSamlIdpStore, OrgSettingsStore, OrgStore, UserStore } from "src/store";

import { InvitationStore } from "./invitation";
import { LoginStore } from "./login";
import { OnboardingStore } from "./onboarding";

const rootReducer = combineReducers({
  branding: BrandingStore.reducer,
  invitation: InvitationStore.reducer,
  login: LoginStore.reducer,
  onboarding: OnboardingStore.reducer,
  org: OrgStore.reducer,
  orgSamlIdp: OrgSamlIdpStore.reducer,
  orgSettings: OrgSettingsStore.reducer,
  user: UserStore.reducer,
});

const cachedState = loadState();
// TODO: remove code below. This is a temporary hack that makes sure that the cached login data has a "data" key.
// This key was introduced in this PR. Some clients might have the old data structure cached:
// This hack makes sure the page still loads even for those clients with a bad cached state
if (cachedState.login && !("data" in cachedState.login)) {
  const loginData = { ...cachedState.login };
  if ("email" in cachedState.login) delete cachedState.login.email;
  if ("org" in cachedState.login) delete cachedState.login.org;
  if ("firstName" in cachedState.login) delete cachedState.login.firstName;
  cachedState.login.data = loginData;
}
const store = configureStore({ reducer: rootReducer, devTools: true, preloadedState: cachedState });
store.subscribe(
  throttle(() => {
    const { email, org, firstName } = store.getState().login.data;
    saveState({
      login: { data: { email, org, firstName } },
    });
  }, 1000),
);

window.store = store.getState;

const StoreProvider = ({ children }) => <Provider store={store}>{children}</Provider>;

export { StoreProvider };
